const RETURN_PATH_KEY = 'impersonationReturnPath';

/**
 * Mémorise la route HashRouter à reprendre après la sortie d'impersonation.
 * @param {string} hashPath - ex. '/admin/feedback'
 */
export function setImpersonationReturnPath(hashPath) {
  try {
    if (hashPath) {
      sessionStorage.setItem(RETURN_PATH_KEY, hashPath);
    }
  } catch {
    /* ignore */
  }
}

/** Lit et efface la route de retour mémorisée (défaut : accueil). */
export function consumeImpersonationReturnPath() {
  try {
    const path = sessionStorage.getItem(RETURN_PATH_KEY);
    sessionStorage.removeItem(RETURN_PATH_KEY);
    if (path && path.startsWith('/')) return path;
  } catch {
    /* ignore */
  }
  return '/';
}

/**
 * Rechargement complet vers l'accueil après le début d'une impersonation.
 *
 * Sécurité : un full reload garantit qu'aucune donnée de l'utilisateur précédent
 * (state React en mémoire, listeners Firestore encore actifs) ne reste accessible.
 * La persistance disque Firestore étant désactivée et le custom token n'étant jamais
 * stocké, il ne subsiste rien de réutilisable côté client après le rechargement.
 */
export function reloadToAccountHome() {
  try {
    sessionStorage.removeItem('impersonation');
  } catch {
    /* ignore */
  }
  // HashRouter : on force l'accueil puis un rechargement dur du document.
  window.location.hash = '/';
  window.location.reload();
}

/**
 * Rechargement complet après la fin d'une impersonation.
 * Retourne au panneau admin mémorisé (ex. /admin/feedback) ou à l'accueil.
 */
export function reloadAfterImpersonationEnd() {
  try {
    sessionStorage.removeItem('impersonation');
  } catch {
    /* ignore */
  }
  window.location.hash = consumeImpersonationReturnPath();
  window.location.reload();
}
